
import "./tester.js";
import "./feature.js";
import "./timeline.js";

console.log('main.js loaded');
window.addEventListener('load', () => {
//  function isMobile() {
// 	return (
// 	  window.innerWidth <= 840 ||
// 	  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
// 		navigator.userAgent
// 	  )
// 	);
//   }
          
});
